module.exports = __webpack_public_path__ + "static/media/weronika.45450a25.jpg";